import * as Constants from '../Constant';

const initialState = {
    message: {},
    medicineList: {},
    lookupNotApplicableFor: {},
    lookupMedicineType: {},
    lookupSalts: {},
    lookupNotes: {},
    lookupChiefComplaint: {},
    lookupTreatmentDetails: {},
    lookupDiagnosis: {},
}

export default function medicineReducer(state = initialState, action) {
    switch (action.type) {
        case Constants.POST_MEDICINE:
            return {
                ...state,
                message: action.payload,
            }
        case Constants.GET_MEDICINE:
            return {
                ...state,
                medicineList: action.payload,
            }
        case Constants.UPDATE_MEDICINE:
            return {
                ...state,
                message: action.payload,
            }
        case Constants.DELETE_MEDICINE:
            return {
                ...state,
                message: action.payload,
            }
        case Constants.LOOKUP_NOT_APPLICABLE_FOR:
            return {
                ...state,
                lookupNotApplicableFor: action.payload,
            }
        case Constants.LOOKUP_SALTS:
            return {
                ...state,
                lookupSalts: action.payload,
            }
        case Constants.LOOKUP_NOTES:
            return {
                ...state,
                lookupNotes: action.payload,
            }
        case Constants.LOOKUP_MEDICINE_TYPE:
            return {
                ...state,
                lookupMedicineType: action.payload,
            }
        case Constants.LOOKUP_CHIEF_COMPLAINT:
            return {
                ...state,
                lookupChiefComplaint: action.payload,
            }
        case Constants.LOOKUP_TREATMENT_DETAILS:
            return {
                ...state,
                lookupTreatmentDetails: action.payload,
            }
        case Constants.LOOKUP_DIAGNOSIS:
            return {
                ...state,
                lookupDiagnosis: action.payload,
            }
        default:
            return state;
    }
}